import React, { FC } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Field, Form } from "react-final-form";

type BarcodeSplitFormProps = {
  submitDisabled: boolean;
  handleSubmit(values: any): void;
  submitGenerateStock(): void;
};

export const BarcodeSplitForm: FC<BarcodeSplitFormProps> = ({ handleSubmit, submitGenerateStock, submitDisabled }) => {
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{
        barcode: "",
        new_weight: (0).toFixed(2),
      }}
      render={({ handleSubmit }) => (
        <form onBlur={handleSubmit} style={{ display: "flex" }}>
          <div style={{ marginRight: "10px" }}>
            <Field
              name="barcode"
              validate={(value) => (value ? undefined : "Barcode ID is required")}
              render={({ input, meta }) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    {...input}
                    variant="filled"
                    placeholder="New Barcode ID"
                    inputProps={{ style: { padding: "10px 12px 10px", width: "250px", color: "green", fontWeight: "bold" } }}
                    InputLabelProps={{ style: { transform: "translate(12px, 12px) scale(1)" } }}
                  />
                  {meta.touched && meta.error && <span style={{ color: "red", fontSize: "13px" }}>{meta.error}</span>}
                </div>
              )}
            />
          </div>
          <div>
            <Field
              name="new_weight"
              validate={(value) => (value ? undefined : "Gross Weight is required")}
              render={({ input, meta }) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    {...input}
                    variant="filled"
                    placeholder="Gross Weight"
                    inputProps={{ style: { padding: "10px 12px 10px", width: "250px", color: "green", fontWeight: "bold" } }}
                    InputLabelProps={{ style: { transform: "translate(12px, 12px) scale(1)" } }}
                  />
                  {meta.touched && meta.error && <span style={{ color: "red", fontSize: "13px" }}>{meta.error}</span>}
                </div>
              )}
            />
          </div>
          <div>
            <Button color="primary" variant="contained" onClick={() => submitGenerateStock()} disabled={submitDisabled} style={{ float: "right", marginLeft: "10px" }}>
              Generate Stock
            </Button>
          </div>
        </form>
      )}
    />
  );
};
